import { constants } from "../constants/redux-constants";
import { REHYDRATE } from "redux-persist/lib/constants";
import i18n, { isLocaleAvailable } from "multilingual";
import { signOut } from "firebase/auth";
import { auth } from "firebase-setup";
import { unixDate } from "config/helpers/date_helper";

const initialState = {
  firstRender: true,
  language: isLocaleAvailable(),
  loader: false,
  theme: "light",
  page_loader: false,
  notification: [],
  isDashboardLoaded: false,
  audioLanguage: isLocaleAvailable(),
  print_watermark: true,
  editWidget: false,
  dashboard_selected_widgets: [],
  auto_delete_days: 0,
  availableFeatures: [],
  notificationModalOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      action.payload?.app.language &&
        i18n.changeLanguage(action.payload?.app.language);
      return {
        ...state,
        ...(action.payload?.app || {}),
        theme: action.payload?.app.theme || "light",
        isDashboardLoaded: false,
      };
    case constants.RESET:
      signOut(auth)
        ?.then(() => {
          let tenantsList = localStorage.getItem("tenants") || "[]";
          localStorage?.clear();
          localStorage.setItem("tenants", tenantsList);
        })
        .catch((e) => {
          console.log(`some issue in firebase signout`, e);
        });
      return {
        ...initialState,
        theme: state.theme,
      };
    case constants.CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case constants.AUDIO_LANGUAGE:
      return {
        ...state,
        audioLanguage: action.payload,
      };
    case constants.PRINT_WATERMARK:
      return {
        ...state,
        print_watermark: action.payload,
      };
    case constants.AUTO_DELETE_DAYS:
      return {
        ...state,
        auto_delete_days: action.payload,
      };
    case constants.APP.CHANGE_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case constants.APP.FULL_PAGE_LOADER:
      return {
        ...state,
        page_loader: action.payload,
      };
    case constants.APP.TOGGLE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case constants?.SET_DASHBOARD_LOADED:
      return {
        ...state,
        isDashboardLoaded: action.payload,
      };
    case constants?.APP?.GENERATE_NOTIFICATIONS:
      // const isNewNotificationExists = state.notification.some(
      //   (item) => item?.id === action?.payload?.id
      // );
      // if (isNewNotificationExists) {
      //   return state;
      // } else {
      return {
        ...state,
        notification: [action?.payload, ...state.notification],
      };
    // }
    case constants?.APP?.EDIT_WIDGET:
      return {
        ...state,
        editWidget: action.payload,
      };
    case constants?.APP?.SET_DASHBOARD_SELECTED_WIDGETS:
      return {
        ...state,
        dashboard_selected_widgets: action.payload,
      };
    case constants?.APP?.DELETE_NOTIFICATIONS:
      return {
        ...state,
        notification: state?.notification?.filter(
          (notification) => notification?.addedOn != action?.payload
        ),
      };
    case constants?.APP?.READ_NOTIFICATIONS:
      return {
        ...state,
        notification: state?.notification?.map((notification) => {
          return {
            ...notification,
            isRead: true,
          };
        }),
      };
    case constants?.APP?.CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notification: [],
      };
    case constants?.APP?.SET_FEATURE_AVAILABILITY:
      return {
        ...state,
        availableFeatures: Array.isArray(action.payload) ? action.payload : [],
      };

    case constants?.APP?.OPEN_NOTIFICATION_MODAL:
      return { ...state, notificationModalOpen: true };

    case constants?.APP?.CLOSE_NOTIFICATION_MODAL:
      return { ...state, notificationModalOpen: false };
      
    default:
      return {
        ...state,
      };
  }
};
